<mat-icon
  [class]="className() ?? 'custom-icon'"
  [svgIcon]="icon()"
  [style.height.px]="size().split('x')[0]"
  [style.width.px]="size().split('x')[1]"
  role="icon"
></mat-icon>
